// @flow
import styled from 'styled-components'
import { oedu_green, oedu_red, oedu_text } from '../../styles/base'
import { Card } from 'antd'

export const StyledCard = styled(Card)`
  & .ant-card-body {
    padding: 24px 0;
  }
`

export const StyledSurprise = styled.div`
  color: ${({ amount }) => {
    let color: string = ''
    color = amount.includes('+') ? oedu_green : color
    color = amount.includes('-') ? oedu_red : color
    color = !color.length || amount === '--' ? oedu_text : color
    return color
  }}
`



// WEBPACK FOOTER //
// ./src/components/table-company-history/style.js